<!--实时值手工填报-->
<template>
  <div class="realTimeValueBody">
    <!--操作表单-->
    <div class="page_top_form">
      <el-form ref="form" label-width="100px">
        <el-form-item label="变量名搜索">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" size="mini" @click="batchEdit">批量确认</el-button>
          <el-button type="primary" size="mini" @click="exportReport">导出当前页</el-button>
          <el-button type="primary" size="mini" @click="exportReport">导出所有</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--列表显示-->
    <div class="tableList" style="padding: 0 20px;">
      <el-table :data="dataList" height="795" border style="width: 100%;" v-loading="loading">
        <template slot="empty">
          <span class="noData">
            <img src="../../assets/noData.png" alt="暂无数据">
            <span class="text">暂无数据</span>
          </span>
        </template>
        <el-table-column type="index" width="90" label="序号">
        </el-table-column>
        <el-table-column prop="CreateVname" label="变量名">
        </el-table-column>
        <el-table-column prop="variableValue" label="实时值">
        </el-table-column>
        <el-table-column prop="variableValue" label="修改值">
          <template slot-scope="scope">
            <el-input v-model="scope.row.variableValue" placeholder="请输入内容"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="380">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="singleDetermine(scope.row)" plain>确定修改</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <elPagination :total="total" :pageSize="pageSize" @pageindexChange="pageindexChange"
      @handleSizeChange="handleSizeChange" />
  </div>
</template>

<script>
  import elPagination from "@/components/module/elComponents/elPagination.vue"
  export default {
    components: {
      elPagination,
    },
    props: {},
    data () {
      return {
        form: {
          name: ''
        },
        dataList: [],
        loading: false,
        pageIndex: 1,
        pageSize: 11,
        total: 0,
        variableNmaes: [],
      }
    },
    created () {
      debugPage=this
    },
    mounted () {
      this.search()
    },
    destroyed () {
      //页面离开
      this.realTimeValueStore.commit("removeKeys",this.variableNmaes)
    },
    computed: {
      realTimeValueStore () {
        return this.$store.realTimeValueStore
      },
      getValue () {
        return this.realTimeValueStore.getters.getValue(this.variableNmaes)
      }
    },
    watch: {
      dataList (nv,ov) {
        //值发生改变时获取实时值
        let nvKey=[]
        let ovKey=[]
        nv.forEach((item,index) => {
          nvKey.push(item.CreateVname)
        })
        ov.forEach((item,index) => {
          ovKey.push(item.CreateVname)
        })
        this.realTimeValueStore.commit("removeKeys",ovKey)
        this.realTimeValueStore.commit("addKeys",nvKey)
      },
      getValue (nv,ov) {
        if(!isempty(nv)) {
          this.dataList.forEach((item,index) => {
            if(nv[index]==undefined) {
              nv[index]=0
            }
            item.variableValue=nv[index]
          })
        }
      }

    },
    methods: {
      singleDetermine (row) {
        let time=new Date().getTime()
        let name="rtValueMap:"+row.CreateVname
        let value=row.variableValue+":"+time
        //提交单个值
        this.$api.realApi.getWriteValues(name,value,respon => {
          this.$message.success(respon)
        },err => {
          this.$message.error("提交失败")
        })
      },
      pageindexChange (val) {
        this.pageIndex=val;
        this.search()
      },
      handleSizeChange (val) {
        //页大小
        this.pageSize=val;
        this.pageIndex=1;
        this.search()
      },
      search () {
        this.variableNmaes=[]
        //查询
        this.$api.manualApi.getManualVariable(this.pageIndex,this.pageSize,respon => {
          //获取实时值
          respon.data.forEach((item,index) => {
            item.variableValue=0
            item.fillin=0
            this.variableNmaes.push(item.CreateVname)
          })
          this.dataList=respon.data
          this.total=respon.total
        },respon => {
          this.$message.error(respon);
        })
      },
      batchEdit () {
        let time=new Date().getTime()
        let name=''
        let value=''
        this.dataList.forEach((item,index) => {
          if(index+1<this.dataList.length) {
            name+="rtValueMap:"+item.CreateVname+','
            value+=item.variableValue+":"+time+','
          } else {
            name+="rtValueMap:"+item.CreateVname
            value+=item.variableValue+":"+time
          }
        })
        this.$api.realApi.getWriteValues(name,value,respon => {
          this.$message.success(respon)
        },err => {
          this.$message.error("提交失败")
        })
      },
      exportReport () {
        //导出
      }
    }
  }
</script>

<style scoped>
  .realTimeValueBody {
    width: 100%;
    height: 100%;
    background-color: white;
  }
</style>